export default __webpack_public_path__ + "static/media/Baruch.a527e37f.jpg";